import { MonitorPlay, PenLine, MessagesSquare, Map } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";

const CARDS = [
  { title: "Live Demonstrations", desc: "Watch practical workflows using AI tools.", Icon: MonitorPlay },
  { title: "Hands-On Homework", desc: "Apply the lessons to your own product idea.", Icon: PenLine },
  { title: "Live Q&A", desc: "Get answers to beginner questions.", Icon: MessagesSquare },
  { title: "Actionable Roadmap", desc: "Know what steps to take after the bootcamp.", Icon: Map },
];

export default function Experience() {
  return (
    <section id="experience" data-testid="experience-section" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHead
          eyebrow="Practical Learning Experience"
          title={<>Don't Just Watch. <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">Learn by Doing.</span></>}
          testId="experience"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={0.1 * i}>
              <div
                data-testid={`experience-card-${i}`}
                className="group h-full rounded-3xl border border-[#E9DFFC] bg-white p-7 text-center transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#7C3AED]/40 hover:shadow-[0_25px_50px_-20px_rgba(124,58,237,0.25)]"
              >
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F6F1FF] text-[#7C3AED] transition-[transform,background-color] duration-300 group-hover:scale-110 group-hover:bg-gradient-to-br group-hover:from-[#9B5CF0] group-hover:to-[#6D28D9] group-hover:text-white">
                  <c.Icon size={24} strokeWidth={2} />
                </span>
                <h3 className="mt-5 text-base font-extrabold tracking-tight text-[#171321]">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#777181]">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
